import { createUrl, restPost } from '~/src/dash/api/rest';
import { BidErrorKey, CampaignNoFillErrorKey } from '~/src/dash/utils/bidErrorCodes';

type AuctionErrorKey = BidErrorKey | CampaignNoFillErrorKey;

export interface AuctionInsightsNode {
  name: string;
  total: number;
  percentage: number;
  values: Record<AuctionErrorKey, number>;
}

export type AuctionInsightKey =
  | 'TotalAdserverInventoryRequest'
  | 'TotalAdserverRequest'
  | 'TotalBidRequested'
  | 'TotalAdserverFilled'
  | 'TotalPacingRejected'
  | 'TotalBidResponse'
  | 'TotalInvalidCreatives'
  | 'TotalAuctionBids'
  | 'TotalBidResponseErrors'
  | 'TotalNoBid'
  | 'TotalBidTimeout'
  | 'TotalValidBids'
  | 'TotalInvalidBids'
  | 'TotalUnwrapErrors'
  | 'TotalBidWon'
  | 'TotalBidLost'
  | 'TotalValidBidsRejected'
  | 'TotalBidderImpression'
  | 'TotalBidderNoImpression'
  | 'TotalConnectionErrors';

interface AuctionInsightsLink {
  source: AuctionInsightKey;
  target: AuctionInsightKey;
  value: number;
}

export interface AuctionInsightsData {
  nodes: Record<AuctionInsightKey, AuctionInsightsNode>;
  links: AuctionInsightsLink[];
}

export interface IGetCampaignAuctionInsightsQueryParams {
  PublisherID: number;
  CampaignID: number;
  StartDate: string;
  EndDate: string;
  Timezone: string;
  LiveDensityRange: string;
  IsRealTimeOnly: boolean;
}

export async function getCampaignAuctionInsights(
  publisherID: string,
  query: unknown,
): Promise<unknown> {
  const reqUrl = `${createUrl('/campaign_auction_insights', publisherID, 'v1')}`;
  const response = await restPost<unknown>(reqUrl, query);
  return (response?.parsedBody as { Insights: unknown })?.Insights || {};
}

export interface IGetBidderAuctionInsightsQueryParams {
  PublisherID: number;
  BidderID: number;
  StartDate: string;
  EndDate: string;
  Timezone: string;
  LiveDensityRange: string;
  IsRealTimeOnly: boolean;
}

export async function getBidderAuctionInsights(
  publisherID: string,
  query: unknown,
): Promise<unknown> {
  const reqUrl = `${createUrl('/bidder_auction_insights', publisherID, 'v1')}`;
  const response = await restPost<unknown>(reqUrl, query);
  return (response?.parsedBody as { Insights: unknown })?.Insights || {};
}
